import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrollPosition, setScrollPosition] = useState(0);

  const toggleMenu = () => {
    if (!isMenuOpen) {
      // Opening menu - save scroll position
      setScrollPosition(window.pageYOffset || document.documentElement.scrollTop);
      document.body.classList.add('menu-open');
      document.body.style.position = 'fixed';
      document.body.style.top = `-${window.pageYOffset}px`;
      document.body.style.width = '100%';
    } else {
      // Closing menu - restore scroll position
      document.body.classList.remove('menu-open');
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      window.scrollTo(0, scrollPosition);
    }
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    if (isMenuOpen) {
      document.body.classList.remove('menu-open');
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      window.scrollTo(0, scrollPosition);
      setIsMenuOpen(false);
    }
  };

  // Close menu on escape key
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape' && isMenuOpen) {
        closeMenu();
      }
    };
    
    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [isMenuOpen]);

  // Close menu on window resize to desktop
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1024 && isMenuOpen) {
        closeMenu();
      }
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [isMenuOpen]);

  return (
    <>
      {/* Mobile Menu Backdrop */}
      {isMenuOpen && (
        <div
          className="mobile-menu-backdrop is-visible"
          onClick={closeMenu}
          aria-hidden="true"
        />
      )}

      <header className="header" role="banner">
        <div className="container">
          <div className="header__content">
            {/* Logo */}
            <div className="logo">
              <Link to="/" className="logo__link" aria-label="Zur Startseite">
                <img
                  src="/images/social-recruiting-berlin-agentur-logo.png"
                  alt="famefact Social Recruiting Berlin"
                  className="logo__image"
                  width="180"
                  height="50"
                />
              </Link>
            </div>

            {/* Mobile Menu Toggle */}
            <button
              className={`mobile-menu-toggle ${isMenuOpen ? 'is-active' : ''}`}
              type="button"
              aria-label={isMenuOpen ? 'Menü schließen' : 'Menü öffnen'}
              aria-expanded={isMenuOpen}
              aria-controls="main-navigation"
              onClick={toggleMenu}
            >
              <span className="hamburger"></span>
            </button>

            {/* Navigation */}
            <nav
              className={`nav ${isMenuOpen ? 'is-open' : ''}`}
              id="main-navigation"
              role="navigation"
              aria-label="Hauptnavigation"
              aria-hidden={!isMenuOpen}
            >
              <ul className="nav__list">
                <li className="nav__item">
                  <Link to="/leistungen" className="nav__link" onClick={closeMenu}>
                    Leistungen
                  </Link>
                </li>
                <li className="nav__item">
                  <Link to="/branchen" className="nav__link" onClick={closeMenu}>
                    Branchen
                  </Link>
                </li>
                <li className="nav__item">
                  <a href="/blog/" className="nav__link" onClick={closeMenu}>
                    Blog
                  </a>
                </li>
                <li className="nav__item mobile-cta-item">
                  <a
                    href="#"
                    className="btn btn--primary btn--full"
                    data-open-consultation
                    data-source="Mobile Menu CTA"
                    onClick={(e) => {
                      closeMenu();
                      // Let the consultation modal handler work
                    }}
                  >
                    Kostenloses Erstgespräch
                  </a>
                </li>
              </ul>
            </nav>

            {/* Desktop CTA Button */}
            <div className="header__cta">
              <a
                href="#"
                className="btn btn--primary"
                data-open-consultation
                data-source="Header CTA"
              >
                Kostenloses Erstgespräch
              </a>
            </div>
          </div>
        </div>
      </header>
    </>
  );
}

export default Header;
